/**
 * Tracks whether this document navigated into the Life Story flow from
 * another in-app screen (the Dashboard or Life & Legacy hero, the item
 * modal, the add-item chooser). The flow's exit may only walk history back
 * when that's true: `window.history.length > 1` can't tell an in-app entry
 * apart from a post-login redirect chain or a restored mobile tab, where
 * "back" lands on single-shot auth interstitials that wipe the fresh session
 * and strand the user on the "Logging Out..." page (TK-3070).
 *
 * Module-level on purpose: a full page load (deep link, tab restore, login
 * redirect) starts a fresh document where the marker is false again.
 *
 * The same entry can ask the flow to open on the chapter picker rather than
 * Review: every "Continue my story" button lands there (TK-3178).
 */

import routerUtils from '../../../../../lib/routerUtils'

let enteredFromApp = false
let pickerRequested = false

/** Navigates into the flow, marking the entry as in-app so exits can go back. */
export const enterLifeStoryFlow = (path, {openPicker = false} = {}) => {
  enteredFromApp = true
  pickerRequested = openPicker
  routerUtils.push(path)
}

export const lifeStoryFlowEnteredFromApp = () => enteredFromApp

/** Whether the entry that brought the user here asked for the chapter picker. */
export const lifeStoryPickerRequested = () => pickerRequested

/** The picker request is one-shot: the flow clears it once it has opened on the picker. */
export const clearLifeStoryPickerRequest = () => { pickerRequested = false }

/** Test-only: the module-level markers would otherwise leak between specs. */
export const resetLifeStoryFlowEntry = () => {
  enteredFromApp = false
  pickerRequested = false
}
